<template>
	<div>
		<div class="dingdan">
			<el-breadcrumb separator-class="el-icon-arrow-right">
			  <el-breadcrumb-item>个人中心</el-breadcrumb-item>
			  <el-breadcrumb-item>意见反馈</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="fh_button" @click="xinjian">
				<i class="el-icon-plus"></i>
				<p>添加反馈</p>
			</div>
		</div>
		<ul class="messageul">
			<figure v-if="list.length==0" style="width:100%;display:flex;justify-content:center;flex-wrap: wrap;">
				<img src="@/assets/kong.png" alt="" srcset="" />
				<figcaption style="width:100%;text-align: center;padding-top:30px;">暂无数据</figcaption>
			</figure>
			<li class="messageli" v-for="(i,index) in list" :key="i.id || index">
				<div class="messageTitle">
					<div class="messagebox">
						<p style="color: #333333;">{{i.content}}</p>
					</div>
					<div style="width:100%; display:flex;justify-content:space-between;align-items: center;margin-top:10px;">
						<p>{{i.create_time}}</p>
						<span v-if="i.reply==''" style="color: #FF5900;">待处理</span>
						<span v-if="i.reply" style="color: #1E3A8A;">已完结</span>
					</div>
				</div>
				<div class="messagebox" style="padding-top:5px;border-top:1px solid #f5f5f5;" v-if="i.reply">
					<span style="font-weight: 400;font-size: 14px;color: #666;word-wrap: break-word;white-space: pre-wrap;word-break: break-all;">平台回复：{{i.reply}}</span>
					<p style="font-weight: 400;font-size: 12px;color: #666;">{{i.update_time}}</p>
				</div>
			</li>
		</ul>
		<div class="fenye" v-if="total>10">
		   <el-pagination
			 background
			 @current-change="handleCurrentChange"
			 :current-page.sync="currentPage1"
			 :page-size="10"
			 layout="total, prev, pager, next ,jumper"
			 :total="total">
		   </el-pagination>
		</div>
		<el-dialog
		  title="意见反馈"
		  :visible.sync="dialogVisible"
		  width="810"
		  :before-close="handleClose">
			  <el-form ref="form" :model="form" label-width="80px" :rules="rules"> 
					<el-form-item label="意见反馈" prop="content">
						 <el-input type="textarea" v-model="form.content"></el-input>
					</el-form-item>
					 <el-form-item label="邮箱" prop="email">
					   <el-input v-model="form.email"></el-input>
					 </el-form-item>
			  </el-form>
			  <span slot="footer" class="dialog-footer">
				<el-button @click="quxiao('form')">取 消</el-button>
				<el-button type="primary" @click="queding('form')">确 定</el-button>
			  </span>
		</el-dialog>
		
	</div>
</template>
<script>
	// import rightsidebarImg from '@/common/rightsidebarImg.vue';
	import { mapState } from 'vuex'
	import {
		FeedbackIndex,
		FeedbackAdd,
	} from "@/api/api.js"
	
	export default {
	  name: 'HelloWorld',
	  components:{
		// rightsidebarImg  
	  },
	  data() {
	    return {
			page:1,
			list:[],
			info:"",
			currentPage1:1,
			pagecount:"",
			total:0,
			dialogVisible:false,
			handleClose:true,
			form:{
				email:"",
				content:""
			},
			rules: {
			  email: [
				 { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
			  ],
			  content: [
				{ required: true, message: '请输入反馈意见', trigger: 'blur' }
			  ],
			 }
	    }
	  },
	  computed: {
	  	...mapState({
	  		user: (state) => state.userInfo || {}
	  	})
	  },
	  watch: {
	  	dialogVisible(val){
	  		if(!val){
	  			this.$nextTick(() => {
	  				if(this.$refs.form){
	  					this.$refs.form.resetFields()
	  				}
	  			})
	  		}
	  	}
	  },
	  created() {
	  	this.msglist()
	  	this.getpersonal()
	  },
	  methods: {
		xinjian(){
			this.dialogVisible=true
		},
		quxiao(formName){
			  this.dialogVisible=false
			  this.$refs[formName].resetFields();
		},
		queding(formName) {
			this.$refs[formName].validate((valid) => {
			  if (valid) {
				this.fabu()
			  } else {
				return false;
			  }
			});
		},
		fabu(){
			FeedbackAdd({
				...this.form
			}).then(res=>{
				if(res.data.status==200){
					this.dialogVisible=false
					this.$message.success("提交成功")
					this.msglist()
				}else{
					// this.$message.error(res.data.msg)
				}
			})
		},
		getpersonal(){
			return this.$store.dispatch('fetchPersonal').then(() => {
				const u = this.user
				if (u && u.review_status == 1) {
					this.value = true
				} else {
					this.value = false
				}
			})
		},
		handleCurrentChange(e){
		  	this.page=e
		  	this.msglist()
		},
		msglist(){
			FeedbackIndex({
				page:this.page,
				limit:"10"
			}).then(res=>{
				this.total=res.data.data.total
				this.pagecount=res.data.data.pass_count
				this.currentPage1=res.data.data.current_page
				this.list=res.data.data.data
			})
		},

	  }
	}
</script>
<style scoped>
	.dingdan{
		width:1200px;
		margin:0 auto;
		padding:36px 0px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.fh_button{
		width: 100px;
		height: 30px;
		line-height:30px;
		background: #1E3A8A;
		border-radius: 4px ;
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
		display:flex;
		align-items:center;
		justify-content:center;
		cursor:pointer;
	}
	.fh_button i{
		margin-right:5px;
	}
	.messageul{
		width:1200px;
		margin:0 auto;
		margin-bottom:20px;
	}
	.messageli{
		width:100%;
		background-color:#fff;
		padding:12px;
		box-sizing: border-box;
		margin-bottom:16px;
		border-radius:12px;
		cursor:pointer;
	}
	.messageTitle{
		width:100%;
		display:flex;
		justify-content:space-between;
		align-items: center;
		flex-wrap:wrap;
		padding-bottom:12px;
	}
	.messageTitle p{
		font-weight: 400;
		font-size: 14px;
		color: #666666;
	}
	.messageTitle img{
		width:16px;
		height:16px;
		margin-right:5px;
	}
	.messageTitle>div{
		display:flex;
		align-items:center;
		position:relative;
	}
	.cjamsji{
		width:5px;
		height:5px;
		background-color:red;
		position:absolute;
		top: 5px;
		border-radius: 50%;
		left: 10px;
	}
	.messagebox{
		width:100%;
		padding-top:12px;
/* 		border-top:1px solid #EFF0F1; */
		font-weight: 400;
		font-size: 16px;
		color: #333333;
	}
	.fenye{
		width:100%;
		padding-bottom:20px;
		display:flex;
		justify-content: center;
	}
	
</style>